import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import moment from 'moment';
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { startDateModStyles } from '../StartDate/StartDateMod.styles';
import { useSelector } from 'react-redux';
import { selectCurrentModDetails, selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { useTranslation } from 'react-i18next';

export const NewEndDate = () => {
  const { classes } = startDateModStyles();
  const { control, formState: { errors }, clearErrors, setError } = useFormContext();
  const value: any = useWatch({ name: 'newEndDate' });
  const { t } = useTranslation();
  const isModEdit = useSelector(selectIsEditMod);
  const selectedModsDetails = useSelector(selectCurrentModDetails);

  const checkDateValidation = date => {
    if (!date || date.toString().length === 0) return 'Required';
    if (selectedModsDetails?.currentStartDate && date && moment(date) < moment(selectedModsDetails?.currentStartDate))
      return 'Must be after Current Start Date';
    return null;
  };

  return (
    <Controller
      control={control}
      name={'newEndDate'}
      rules={{
        validate: checkDateValidation,
      }}
      render={({ field: { onChange, value, ...rest } }) => {
        const newEndDate = moment(value ?? null);
        return (
          <React.Fragment>
            <DateRangePicker
              onChange={newValue => {
                clearErrors('newEndDate');
                if (newValue.startDate !== undefined) {
                  const newDate = moment(newValue.startDate);
                  const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;
                  onChange(setTo);
                } else {
                  onChange(null);
                }
              }}
              value={value}
              onCancel={() => {}}
              clear
              required={true}
              open={false}
              quickSelect={false}
              variant="filled"
              single
              placeholder={t('placement.placementMods.newEndDate')}
              useMaxWidth={true}
              showIcon={true}
              className={classes.inputFields}
              actionBar={false}
              clickAway={true}
              trailingIconShow={true}
              readOnly={!isModEdit}
              keepClickAwayVal={true}
              initialDateRange={{
                startDate: newEndDate.isValid() ? new Date(newEndDate.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                endDate: newEndDate.isValid() ? new Date(newEndDate.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                useLabelAsValue: true,
              }}
              onInlineEdit={val => {
                const fieldValue = val.substring(0, val.length - 1);
                if (!value && !moment(fieldValue).isValid()) {
                  setError('newEndDate', {
                    type: 'validate',
                    message: 'Invalid Format',
                  })
                } else clearErrors('newEndDate')
              }}
              error={!isNullOrUndefined(errors?.newEndDate)}
              helperText={!isNullOrUndefined(errors?.newEndDate) ? errors?.newEndDate?.message : undefined}
            />
          </React.Fragment>
        );
      }}
    />
  );
};
